import {IRootState} from "../../store/store";
import {getIsUserAuthenticatedApi} from "../api/get_is_user_authenticated";

export const selectGetIsUserAuthenticated = (state: IRootState): boolean => {
    const cachedQuery = getIsUserAuthenticatedApi.endpoints.getIsUserAuthenticated.select(undefined)(state);
    return cachedQuery.isSuccess && !!cachedQuery.data;
};
